import DeliveryService from "../DeliveryService"


const Product = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    gets() {
        return DeliveryService.get(`/products`)
    },
    get(id) {
        return DeliveryService.get(`/products/` + id)
    },
    add(data) {
        return DeliveryService.post(`/console/products`, data)
    },
    update(data) {
        return DeliveryService.put(`/console/products/` + data.product_id, data)
    },
    upload(data) {
        var block = data.image.split(";");
        var contentType = block[0].split(":")[1];
        var realData = block[1].split(",")[1];

        var blob = this.b64toBlob(realData, contentType);

        let formData = new FormData();
        formData.append("image", blob);

        return DeliveryService.upload(`/console/products/` + data.product_id + `/upload`, formData)
    },
    editCategory(data) {
        return DeliveryService.post(`/console/products-category/` + data.cateId, data)
    },
    removeCategory(id) {
        return DeliveryService.post(`/console/products-category/` + id + `/remove`, null)
    },
    b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || "";
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (
            var offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
        ) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
}

export default Product